import React from 'react';
import { useCountdown } from './useCountdown';
import TimerDisplay from './TimerDisplay';
import './timer.css';

const ExpiredNotice = () => {
    return (
        <div className="expired-notice">
            <span>Expired!!!</span>
            <p>Please select a future date and time.</p>
        </div>
    );
};

const ShowCounter = ({ days, hours, minutes, seconds }) => {
    return (
        <div className="show-counter">

            <div className='title_text_div'>
                <p className='title_text'>Notre site est en cours de développement.</p>
                <p className='title_text'>Our website is coming soon.</p>
            </div>

            <div className="countdown-link">
                <TimerDisplay value={days} type={'Days'} isDanger={days <= 3} />
                <p><img src={process.env.PUBLIC_URL + 'assets/images/icon/Line.webp'} alt=".." className='hypen-img' /></p>
                <TimerDisplay value={hours} type={'Hours'} isDanger={false} />
                <p><img src={process.env.PUBLIC_URL + 'assets/images/icon/Line.webp'} alt=".." className='hypen-img' /></p>
                <TimerDisplay value={minutes} type={'Mins'} isDanger={false} />
                <p><img src={process.env.PUBLIC_URL + 'assets/images/icon/Line.webp'} alt=".." className='hypen-img' /></p>
                <TimerDisplay value={seconds} type={'Seconds'} isDanger={false} />
            </div>
        </div>
    );
};

const Timer = ({ targetDate }) => {
    const [days, hours, minutes, seconds] = useCountdown(targetDate);

    if (days + hours + minutes + seconds <= 0) {
        return <ExpiredNotice />;
    } else {
        return (
            <ShowCounter
                days={days}
                hours={hours}
                minutes={minutes}
                seconds={seconds}
            />
        );
    }
};

export default Timer;